/* eslint-disable no-use-before-define */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import * as React from "react";
import { useTranslation } from "react-i18next";
import DataTable from "../../Tables/DataTable";
import formatDate from "../../../helpers/formatDateMaintenance";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

export default function MaintenanceClosing(props) {
  const { t } = useTranslation("common");
  const [rows, setRows] = React.useState([]);
  const [tmpValue, setTmpValue] = React.useState([]);
  const [totalValue, setTotalValue] = React.useState(0); // 🔸 NOVO STATE

  const columns = [
    { Header: t("common.date"), accessor: "date", align: "left" },
    { Header: t("common.ctnr"), accessor: "container", align: "left" },
    { Header: t("modal.mod_input_value"), accessor: "value", align: "left" },
  ];

  React.useEffect(() => {
    const data = props?.content.data;
    const keysData = Object.keys(data || {});
    const tempValue = [];

    keysData.forEach((keyData) => {
      tempValue.push(data[keyData].material_item);
    });

    setTmpValue(tempValue);
  }, []);

  React.useEffect(() => {
    const data = props?.content.data;
    const keys = Object.keys(data || {});
    const Maintenance = props?.content.maintenanceValue;

    const tmpRow = [];
    let total = 0; // 🔸 ACUMULADOR

    keys.forEach((key) => {
      const execDate = data[key].execution_date;
      const container = data[key].container;
      const items = data[key].material_item;

      const subtotal = items.reduce((acc, item) => acc + item.value * item.quantity, 0);
      const rowValue = subtotal + Maintenance;

      total += rowValue; // 🔸 SOMANDO AO TOTAL

      tmpRow.push({
        date: formatDate(execDate),
        container,
        value: new Intl.NumberFormat("pt-BR", {style: "currency", currency: "BRL" }).format(rowValue),
      });
    });

    setRows(tmpRow);
    setTotalValue(total); // 🔸 DEFININDO TOTAL
  }, [props]);

  return (
    <>
      <div style={{ width: "100%" }}>
        <DataTable
          table={{ columns, rows }}
          isSorted={false}
          entriesPerPage={false}
          showTotalEntries={false}
          noEndBorder
        />
      </div>

      <Grid container>
        <Grid xs={12} mt={4} mb={4} item>
          <Box style={{ display: "flex", justifyContent: "center" }} className="text-title">
            {`${t("maintenance.title_total")} ${new Intl.NumberFormat("pt-BR", {
              style: "currency",
              currency: "BRL",
            }).format(totalValue)}`}
          </Box>
        </Grid>
      </Grid>
    </>
  );
}
